<div class="step" [ngClass]="{ 'current-step': currentRoute === 'placead', 'last-step': currentRoute === 'login' }">
	<span class="step-index" [ngStyle]="{ 'font-size': viewport.type !== 'desktop' ? '1.5em' : '5em' }">
		{{ locale.translations['place-ad']['place-ad-stepper']['n124'] }}
	</span>
	<span
		class="step-label"
		[ngStyle]="{ 'font-size': viewport.type !== 'desktop' ? '0.8em' : '1em', 'padding-top': viewport.type !== 'desktop' ? '0.5em' : '1em' }"
	>
		{{ locale.translations['place-ad']['place-ad-stepper']['n123'] }}
	</span>
</div>

<div class="step" [ngClass]="{ 'current-step': currentRoute === 'login' }">
	<span class="step-index" [ngStyle]="{ 'font-size': viewport.type !== 'desktop' ? '1.5em' : '5em' }">
		{{ locale.translations['place-ad']['place-ad-stepper']['n125'] }}
	</span>
	<span
		class="step-label"
		[ngStyle]="{ 'font-size': viewport.type !== 'desktop' ? '0.8em' : '1em', 'padding-top': viewport.type !== 'desktop' ? '0.5em' : '1em' }"
	>
		{{ locale.translations['logup']['login']['n51'] }} &#47; {{ locale.translations['logup']['signup']['n56'] }}
	</span>
</div>

<mat-divider [ngStyle]="{ margin: viewport.type !== 'desktop' ? '1.5em 0' : '3em 0' }"></mat-divider>
